import { MultiEmailInputV2, CustomButton, CustomInput } from '@/shared/ui/components';
import _ from 'lodash';
import { t } from 'ttag';
import { useAbortStudy } from './useAbortStudy';
import MultiIdSearchInput from '../components/multiSearchInput';
import SEND_REQUEST from '../submitARequest.constants';
import type { AbortStudyProps } from './abortStudy.types';
import './styles.scss';

const AbortStudy = ({
  category,
  selectedFacility,
  setLoadingPage,
  backToPrevious,
}: AbortStudyProps) => {
  const {
    state,
    onChange,
    onClickSendMessage,
    onChangeEmailList,
    onInputChange,
    handleOnPaste,
    onInputChangeMultiIdSearch,
    onChangeMultiIdSearch,
    onKeyDownCreatableSelect,
    handleClickOutside,
  } = useAbortStudy({ category, selectedFacility, setLoadingPage, backToPrevious });

  return (
    <div className="abort-study-box">
      <div className="study-id-box">
        <span className="big-title">{t`Request information`}</span>
        <MultiIdSearchInput
          classNamePrefix="multi-id-search"
          title={
            <span>
              <span className="text-bold">Study ID</span> (type in or paste all the IDs separated by
              commas or spaces)
            </span>
          }
          placeholder={t`Enter study IDs, comma or space separated`}
          value={state.multiSearchValue}
          onPaste={handleOnPaste}
          inputValue={state.inputValue}
          onInputChange={onInputChangeMultiIdSearch}
          onChange={onChangeMultiIdSearch}
          onKeyDown={onKeyDownCreatableSelect}
          onBlur={handleClickOutside}
        />
      </div>

      <div className="message-box">
        <span className="small-title">Message</span>
        <CustomInput
          className="message-text"
          placeholder={t`Enter your message`}
          type="textarea"
          value={state.message}
          onChange={onChange}
          name="message"
          allowClear={false}
        />
      </div>
      <div className="email-box">
        <span className="big-title">{t`Notification email`}</span>
        <MultiEmailInputV2
          emailList={state.emailList}
          emailInputValue={state.emailInputValue}
          onChangeEmailList={onChangeEmailList}
          onInputChange={onInputChange}
          isError={!_.isEmpty(state.errorObject.invalidEmails)}
          errorMessage={state.errorObject.invalidEmails}
        />
      </div>

      <div className="bottom-button-row">
        <CustomButton
          id="submit-btn"
          className="button-submit"
          disabled={
            (_.isEmpty(state.emailList) && !state.emailInputValue) ||
            !state.message ||
            state.isSaving ||
            state.multiSearchValue.length === 0 ||
            _.some(state.multiSearchValue, (x) => !_.isEmpty(x.errorMessage))
          }
          onClick={() => setTimeout(onClickSendMessage, 100)}
        >
          {SEND_REQUEST}
        </CustomButton>
      </div>
    </div>
  );
};

export default AbortStudy;
